import styled from "@emotion/styled";
import { Typography, useTheme, Theme, Button } from "@yuno/design-system-web";
import { useNavigate } from "react-router-dom";
import emptyImage from "../../assets/empty_state.svg";
import { useTranslation } from 'react-i18next'

const Container = styled("div")(({ theme }: { theme?: Theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "577px",
  height: "577px",
  borderRadius: "24px",
  background: "white",
}));

const Title = styled(Typography)(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.neutral.black,
  marginBottom: "8px",
  fontWeight: 700,
  fontSize: "16px",
  marginTop: "8px",
}));

const Subtitle = styled(Typography)(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.grey[5],
  width: "328px",
  fontWeight: 400,
  fontSize: theme.typography.tiny.regular.fontSize,
  marginBottom: "24px",
}));

const ButtonStyled = styled(Button)(({ theme }: { theme?: Theme }) => ({
  "&.MuiButtonBase-root": {
    fontSize: theme.typography.tiny.regular.fontSize,
  },
}));

export const EmptyState = ({ title, description, link = "", image = "" }) => {
  const { t } = useTranslation()
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  return (
    <Container>
      <img src={image || emptyImage} alt="empty" />
      <Title align="center">{title}</Title>
      <Subtitle align="center">{description}</Subtitle>
      {link && (
        // @ts-ignore
        <ButtonStyled
          variant="tertiary"
          size="small"
          onClick={navigate.bind(null, "/routing")}
        >
          {t('goToRouting')}
        </ButtonStyled>
      )}
    </Container>
  );
};
